import React from "react";
import { StateForm } from "./Forms/StateForm";
import { useCreateStateMutation } from "../../services/basicData/basicData";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { PageHeader } from "../../CommonElements/PageTitle";
import { Container, Form, Spinner } from "reactstrap";
import { Stack } from "react-bootstrap";

export const CreateState = () => {
  const {
    handleSubmit,
    control,
    formState: { errors },
    setError,
  } = useForm({
    defaultValues: {
      name: "",
      code: "",
    },
  });

  const { mutate: createState, isPending } = useCreateStateMutation(setError);
  const { t } = useTranslation();

  const onSubmit = (data) => {
    createState(data);
  };

  return (
    <Stack gap={2}>
      <PageHeader title={t("CREATE_STATE")}  />
      <Container fluid>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <StateForm control={control} errors={errors} />
          <Button variant="primary" type="submit" disabled={isPending}>
            {isPending ? (
              <>
                <Spinner size="sm" />
                {t("CREATING_STATE")}
              </>
            ) : (
              t("CREATE_STATE")
            )}
          </Button>
        </Form>
      </Container>
    </Stack>
  );
};

